module.exports = __webpack_public_path__ + "static/img/login_logo.74aacc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_logo.png
// module id = sC/+
// module chunks = 2